import React from 'react'

class GroupCheckbox extends React.Component {
  state = {
    selectAll: false,
  }

  checkSelected(id) {
    if (this.props.selected && this.props.selected.length > 0) {
      return this.props.selected.includes(id)
    } else {
      return false
    }
  }

  onChange(id) {
    let selected = []
    if (this.props.selected && this.props.selected.length > 0) {
      selected = this.props.selected
    }

    if (selected.includes(id)) {
      let index = selected.indexOf(id)
      selected.splice(index, 1)
    } else {
      selected.push(id)
    }

    this.props.onChange(selected)

    setTimeout(() => {
      this.setState({
        selectAll: this.props.selected.length == this.props.list.length,
      })
    }, 100)
  }

  selectAll() {
    this.setState(
      {
        selectAll: !this.state.selectAll,
      },
      () => {
        let selected = []
        if (this.state.selectAll) {
          selected = this.props.list.map((item) => item[this.props.idKey || 'id'])
        }

        this.props.onChange(selected)
      }
    )
  }

  render() {
    return (
      <div className="form-group row">
        <label className="col-2 col-form-label">{this.props.title || 'Label'}</label>
        <div
          className="col-10"
          style={{ paddingRight: 30 }}
        >
          <div
            className="row"
            style={{
              border: '1px solid #ccc',
              padding: 10,
            }}
          >
            {this.props.list.length > 0 ? (
              <>
                <div
                  className={
                    this.props.grid == 1
                      ? 'col-12'
                      : this.props.grid == 2
                        ? 'col-6'
                        : this.props.grid == 3
                          ? 'col-4'
                          : this.props.grid == 4
                            ? 'col-3'
                            : 'col-lg-3 col-md-4 col-sm-6 col-xs-12'
                  }
                >
                  <label style={{ display: 'flex', marginBottom: 0 }}>
                    <input
                      style={{ marginRight: 10 }}
                      type="checkbox"
                      checked={this.state.selectAll}
                      onChange={() => this.selectAll()}
                    />
                    <span> {'Select All'}</span>
                  </label>
                </div>
                {this.props.list.map((item, index) => (
                  <div
                    className={
                      this.props.grid == 1
                        ? 'col-12'
                        : this.props.grid == 2
                          ? 'col-6'
                          : this.props.grid == 3
                            ? 'col-4'
                            : this.props.grid == 4
                              ? 'col-3'
                              : 'col-lg-3 col-md-4 col-sm-6 col-xs-12'
                    }
                    key={index}
                  >
                    <label style={{ display: 'flex', marginBottom: 0 }}>
                      <input
                        style={{ marginRight: 10 }}
                        type="checkbox"
                        checked={this.checkSelected(item[this.props.idKey || 'id'])}
                        id={item[this.props.idKey || 'id']}
                        onChange={() => this.onChange(item[this.props.idKey || 'id'])}
                      />
                      <span> {item[this.props.displayKey || 'name']}</span>
                    </label>
                  </div>
                ))}
              </>
            ) : (
              <div className="col-12 text-center">Empty List</div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default GroupCheckbox
